import {useMutation} from "react-query";
import {PostNavigation} from "./monitoringNavigation.services";


export const useAddNavigation = ()=>{
    return useMutation((datas:MonitoringPost)=>{
        return PostNavigation(datas);
    })
}